import { Container } from "@/components/ui/container";
import { Button } from "@/components/ui/button";
import { footerLinks, loginUrl, signupUrl } from "@/lib/content";

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-secondary/30">
      <Container className="py-12">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[1.3fr_repeat(4,1fr)]">
          <div>
            <a href="/" className="flex items-center gap-2 text-base font-bold text-foreground">
              <img
                src="/brand/logo-icon.svg"
                alt=""
                className="h-7 w-auto shrink-0"
                width={28}
                height={35}
              />
              <span>
                DataProtection<span className="text-primary">.work</span>
              </span>
            </a>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-muted-foreground">
              Jurisdiction-aware privacy operations for small businesses. Philippines / PH DPA and GDPR / EU are the committed launch packs, with Canada and US/state expansion planned.
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <Button variant="outline" size="sm" asChild>
                <a href={loginUrl}>Log In</a>
              </Button>
              <Button variant="primary" size="sm" asChild>
                <a href={signupUrl}>Start Free</a>
              </Button>
            </div>
          </div>

          {Object.entries(footerLinks).map(([heading, links]) => (
            <nav key={heading} aria-label={heading}>
              <h3 className="text-sm font-semibold text-foreground">{heading}</h3>
              <ul className="mt-3 space-y-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-border pt-6 text-xs text-muted-foreground sm:flex-row sm:items-start sm:justify-between">
          <p>&copy; {year} DataProtection.work. All rights reserved.</p>
          <p className="max-w-2xl sm:text-right">
            DataProtection.work provides practical guidance and does not make a binding legal determination or guarantee legal or regulatory compliance.
          </p>
        </div>
      </Container>
    </footer>
  );
}
